<div role="form" [innerHtml]="eventmarketingformhtml | safe:'html'" registration-form-initializer [formHandler]="formHandler">
</div>